<template>
  <PageVC figure-hidden class="order table-menu">
    <div class="a-container">
      <h1 class="a-page-title">Menu</h1>
      <HUILoadingView v-if="!order || !entered || !menu" />
      <template v-else>
        <Menu
          class="a-container__offset"
          :is-lunch="order.is_lunch"
          @add-burger="handleMenuAddBurger"
          @add-product="handleMenuAddProduct"
        ></Menu>
        <div class="a-order-buttons">
          <div class="a-order-buttons__inner">
            <div class="a-button-group">
              <RouterButton
                :to="{ name: routes.TABLE_CART, params: { orderToken: $route.params.orderToken }}"
              >Se ordre</RouterButton>
              <HUIButton
                v-if="numUnsentItems > 0"
                :disabled="interactionShouldBeDisabled"
                :spinner="sending"
                theme="green"
                @click="handleSendToKitchenClick"
              >Bestil</HUIButton>
            </div>
          </div>
        </div>
      </template>
    </div>
  </PageVC>
</template>

<script>
import { HUILoadingView, HUILegendWithBullets, HUIButton } from '@/halifax-ui'
import TableBase from '@/views/TableBase'
import PageVC from '@/containers/PageVC'
import RouterButton from '@/containers/RouterButton'
import Menu from '@/containers/Menu'

export default {
  extends: TableBase,
  components: {
    PageVC,
    HUILoadingView,
    RouterButton,
    HUILegendWithBullets,
    Menu,
    HUIButton
  },
  data() {
    return {
      sending: false
    }
  },
  computed: {
    interactionShouldBeDisabled() {
      return this.sending || this.order.is_locked
    }
  },
  methods: {
    async handleMenuAddBurger(config) {
      const payload = {
        type: 'burger',
        burger_id: config.id,
        bun_id: config.bun,
        patty_id: config.patty,
        frying_id: config.frying,
        ingredients: config.ingredients,
        quantity: config.quantity
      }

      try {
        await this.$store.dispatch('order/ADD_ITEM', { payload, orderToken: this.orderToken })
      } catch (error) {
        this.$store.dispatch('toast/ERROR', error.message)
      }
    },
    async handleMenuAddProduct({ id, quantity }) {
      const payload = {
        type: 'product',
        product_id: id,
        quantity
      }

      try {
        await this.$store.dispatch('order/ADD_ITEM', { payload, orderToken: this.orderToken })
      } catch (error) {
        this.$store.dispatch('toast/ERROR', error.message)
        this.fetchOrder()
      }
    },
    async handleSendToKitchenClick() {
      this.sending = true
      const canChangeOrder = await this.canChangeOrder()

      if (canChangeOrder) {
        try {
          const didConfirm = await this.$store.dispatch('dialog/CONFIRM', {
            props: {
              heading: 'Er alle færdige?',
              body: 'Når du trykker ok, sendes hele bordets bestilling af sted.'
            }
          })
          if (didConfirm) {
            await this.$store.dispatch('order/SEND_TO_KITCHEN', this.orderToken)
            await this.fetchOrder()

            this.$store.dispatch('dialog/ALERT', {
              props: {
                heading: 'Tak for din bestilling.',
                body: 'Vi glæder os til at servere den for dig.'
              }
            })
          }
        } catch (error) {
          this.$store.dispatch('toast/ERROR', error.message)
        } finally {
          this.sending = false
        }
      } else {
        this.sending = false
      }
    }
  }
}
</script>

<style lang="scss">
@import '~@/scss/variables';
@import '~@/halifax-ui/src/scss/framework';

.table-menu {
  $module: '.table-menu';

  padding-bottom: 160px;

  @include supports-safe-area-insets {
    padding-bottom: calc(var(--safe-area-inset-bottom) + 160px);
  }
  &__multiplayer {
    margin-bottom: 50px;
  }
  &__multiplayer-share {
    margin-bottom: 30px;
  }
  &__legend {
    margin-bottom: 20px;
  }
  &__legend-explainer {
    font-weight: 700;
    text-align: center;
    margin-bottom: 30px;
    font-size: 1.3rem;
  }
}
</style>
